// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { forwardSlash16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-forward-slash': IconForwardSlash;
    }
}

/**
 * The icon component for the 'forwardSlash' icon
 */
export class IconForwardSlash extends IconSvg {
    public constructor() {
        super(forwardSlash16X16);
    }
}

registerIconSvg('icon-forward-slash', IconForwardSlash);
export const iconForwardSlashTag = 'nimble-icon-forward-slash';
